import Product from "@/api/Product";
import Review from "@/api/Review";

export class ProductReviewDTO {
    product?: Product;
    reviews?: Review[];
}

export default class ProductReview extends ProductReviewDTO {
    constructor(dto?: ProductReviewDTO) {
        super();
        if (dto) {
            Object.assign(this, dto);
        }
    }
}